// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — denominations2.styled.classic.js, новая — denominations2.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './denominations2.styled.classic';
import * as cp from './denominations2.styled.cp';

export const CashTable = isCp ? cp.CashTable : classic.CashTable;
export const Center = isCp ? cp.Center : classic.Center;
export const Content = isCp ? cp.Content : classic.Content;
export const InfoHeader = isCp ? cp.InfoHeader : classic.InfoHeader;
export const Nominal = isCp ? cp.Nominal : classic.Nominal;
export const NominalTitle = isCp ? cp.NominalTitle : classic.NominalTitle;
